import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    NgZone,
    OnDestroy,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { Theme } from '@app-state';

import {
    animationFrameScheduler,
    fromEvent,
    merge,
    Subject,
} from 'rxjs';
import {
    take,
    takeUntil,
    throttleTime,
} from 'rxjs/operators';

const DIMENSIONS_RATIO = 15 / 23;
const RESIZE_THROTTLE = 128;

@Component({
    selector: 'ui-theme-preview',
    templateUrl: './ui-theme-preview.html',
    styleUrls: ['./ui-theme-preview.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class UiThemePreviewComponent implements OnDestroy {
    @Input()
    @HostBinding('class')
    public theme!: Theme;

    @Output()
    public select = new EventEmitter<Theme>();

    public dimensions?: {
        componentHeight: number,
        itemHeight: number,
        itemBorderRadius: number,
        bulletDiameter: number,
    };

    public navbarMenuClasses = ['default', 'orange'];
    public cardElementClasses = ['default', 'green', 'orange'];
    public sidebarMenuItems = new Array(3).fill(0);

    private _destroyed$ = new Subject();

    constructor(
        zone: NgZone,
        private _el: ElementRef,
        private _cd: ChangeDetectorRef,
    ) {
        merge(
            fromEvent(window, 'resize')
                .pipe(
                    throttleTime(RESIZE_THROTTLE, animationFrameScheduler, {
                        leading: false,
                        trailing: true,
                    }),
                ),
            zone.onStable
                .pipe(
                    take(1),
                ),
        ).pipe(
            takeUntil(this._destroyed$),
        ).subscribe(
            () => this.onResize(),
        );
    }

    ngOnDestroy() {
        this._destroyed$.next();
    }

    public onHostClick(ev: MouseEvent) {
        ev.preventDefault();
        ev.stopImmediatePropagation();

        this.select.emit(this.theme);
    }

    public onResize() {
        const { width } = this._el.nativeElement.getBoundingClientRect();
        const componentHeight = width * DIMENSIONS_RATIO;

        this.dimensions = {
            componentHeight,
            itemHeight: componentHeight * .08,
            itemBorderRadius: componentHeight * .04,
            bulletDiameter: componentHeight * .1,
        };

        this._cd.detectChanges();
    }
}
